export enum FlowTypes {
  NewDevice = "newdevice",
  Replacement = "replacement",
}
